import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  constructor(public auth: AuthService, private router: Router) {}

  ngOnInit() {
    if (this.auth.isAuthenticated()) {
      this.auth.getProfile(() => {
        this.router.navigate(['feedbacks']);
        // if (this.auth.userProfile && this.auth.userProfile.user_metadata && this.auth.userProfile.user_metadata.tos_accepted) {
        //   this.router.navigate(['announcements']);
        // } else {
        //   this.router.navigate(['tos']);
        // }
      });
    }
  }
}



// WEBPACK FOOTER //
// /ng-app/src/app/shared/home/home.component.ts